export default __webpack_public_path__ + "fonts/ttf/iranyekanwebbold.ttf";